import React from 'react';
import { useSelector } from 'react-redux';

const KoalaPopup = props => {
  
  const appProps = useSelector(store => store.app),
        isAdmin = appProps.loggedInUser !== null && (appProps.loggedInUser.is_admin || appProps.loggedInUser.is_akfstaff);
  
  return (
    <>
      {
        props.photo !== '' &&
        props.photo !== undefined &&
        <div className="map__popup-image" style={{ backgroundImage: `url("${ props.photo }")` }}>&nbsp;</div>
      }
            
      <div className="map__popup-content">

        {
          props.datetime_of_sighting &&
          props.datetime_of_sighting !== 'null' &&
          <p className="map__popup-text"><b>Sighting Date:</b> { new Date(props.datetime_of_sighting).toLocaleString('en-AU') }</p>
        }
        {
          isAdmin &&
          props.first_Name &&
          props.first_Name !== 'null' &&
          <p className="map__popup-text"><b>Sighting by: </b> { `${ props.first_Name } ${ props.surname }` }</p>
        }
        {
          props.location && 
          props.location !== 'null' && 
          <p className="map__popup-text"><b>Koala location:</b> { props.location }</p>
        }
        {
          props.status && 
          props.status !== 'null' && 
          <p className="map__popup-text"><b>Koala status:</b> { props.status }</p>
        }
        {
          props.sex &&
          props.sex !== 'null' &&
          <p className="map__popup-text"><b>Sex:</b> { props.sex }</p>
        }
        {
          props.tree_species &&
          props.tree_species !== 'null' && 
          <p className="map__popup-text"><b>Tree species:</b> { props.tree_species }</p>
        }
        {
          props.with_joey !== 'null' &&
          <p className="map__popup-text"><b>With joey?</b> { props.with_joey ? 'Yes' : 'No' }</p>
        }
        {
          props.more_information &&
          props.more_information !== 'null' && 
          <p className="map__popup-text"><b>More information:</b> { props.more_information }</p>
        }
        
      </div>
    </>
  );

}

export default KoalaPopup;